/** Titre d'accordéon (overview) : gras, le contenu restant en regular. */
export const ACCORDION_TITLE_CLASS = "font-bold";

export const ACCORDION_LIST_CONTENT_CLASS =
  "font-normal text-sm leading-[110%] subpixel-antialiased font-sans [&_*]:!text-[14px] [&_*]:!leading-[110%]";

/** @deprecated Use ACCORDION_LIST_CONTENT_CLASS */
export const AccordionClass = ACCORDION_LIST_CONTENT_CLASS;

export const ACCORDION_ROW_SPACING_STYLE = "margin-bottom: 0.5rem";

export function renderRowsWithSpacing(rows: string[]): string {
  return rows
    .map((row, index) => {
      const style =
        index === rows.length - 1
          ? ""
          : ` style="${ACCORDION_ROW_SPACING_STYLE};"`;
      return `<div${style}>${row}</div>`;
    })
    .join("");
}

function stripHtml(html: string): string {
  return html.replace(/<[^>]*>/g, "").trim();
}

function splitAccordionListHtml(html: string): string[] {
  return html
    .split(/<br\s*\/?>/gi)
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0 && stripHtml(segment).length > 0);
}

export function normalizeAccordionListHtml(html: string): string {
  const trimmed = html?.trim() ?? "";
  if (!trimmed) return "";

  if (trimmed.includes(ACCORDION_ROW_SPACING_STYLE)) {
    return trimmed;
  }

  const rows = splitAccordionListHtml(trimmed);
  if (rows.length <= 1) {
    return trimmed;
  }

  return renderRowsWithSpacing(rows);
}
